/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.outerwrap[_ngcontent-%COMP%]{height:100%}.scroll[_ngcontent-%COMP%]{overflow-y:auto}.bottomactionbar[_ngcontent-%COMP%]{margin-top:15px}.alert[_ngcontent-%COMP%]{margin-top:20px;color:red}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/services/dialogs/adoptioncoursesearch/adoptioncoursesearch.dialogcomponent.css.shim.ngstyle.js.pre-build-optimizer.js